class ReadMore extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isOpen = false
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(document, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const trigger = event.target.closest(this.els?.trigger?.selector)
    if (!trigger || !this.contains(trigger)) return

    event.preventDefault()

    this.toggle()
  }

  toggle () {
    this.isOpen = !this.isOpen

    this.toggleAttribute('data-open', this.isOpen)

    this.updateTrigger()
  }

  updateTrigger () {
    const trigger = this.els.trigger.element
    if (!trigger) return

    trigger.innerHTML = this.isOpen
      ? this.dataset.readLess
      : this.dataset.readMore

    trigger.setAttribute('aria-expanded', this.isOpen)
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore)
}
